import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { ROUTE_CONSTANTS } from '../constants/route.constant';

/** Allows navigation only when router state includes a recent `timestamp` (10s window). */
@Injectable({
    providedIn: 'root',
})
export class TempPageGuard implements CanActivate, CanActivateChild {
    constructor(private readonly router: Router) {}

    canActivate(): Observable<boolean | UrlTree> {
        return this.checkAccess();
    }

    canActivateChild(): Observable<boolean | UrlTree> {
        return this.checkAccess();
    }

    private checkAccess(): Observable<boolean | UrlTree> {
        const nav = this.router.currentNavigation();
        const navigationState = nav?.extras?.state;

        const timestamp = navigationState?.['timestamp'];
        const now = Date.now();

        if (typeof timestamp !== 'number' || now - timestamp > 10_000) {
            this.router.navigate([ROUTE_CONSTANTS.HOME]);
            return of(false);
        }

        return of(true);
    }
}
